import React from 'react'
import PageLayout from '../components/PageLayout'
import SearchHeader from '../components/SearchHeader'
import NewNotice from '../components/notices/NewNotice'

const CreateNoticesPage = () => {
  return (
    <>
      <PageLayout>
        <SearchHeader />
        <div className="inner-main-content">
          <NewNotice />
        </div>
      </PageLayout>
    </>
  )
}

export default CreateNoticesPage
